module.exports = __webpack_public_path__ + "static/media/vw-transporter3.5097a058.jpg";